import "./CompanyOverview.css";

import {
    FaEye,
    FaBullseye,
    FaLightbulb,
    FaAward,
    FaHandshake,
    FaLeaf
} from "react-icons/fa";

function CompanyOverview() {

    const values = [

        {
            icon: <FaLightbulb />,
            title: "Innovation",
            text: "Developing smarter packaging solutions through continuous improvement."
        },

        {
            icon: <FaAward />,
            title: "Quality",
            text: "Maintaining consistent manufacturing standards with dependable performance."
        },

        {
            icon: <FaHandshake />,
            title: "Customer Partnership",
            text: "Building long-term relationships through trust, service and commitment."
        },

        {
            icon: <FaLeaf />,
            title: "Responsibility",
            text: "Supporting sustainable manufacturing and responsible business practices."
        }

    ];

    return (

        <section
            className="company-overview"
            id="about"
        >

            <div className="container-custom">

                <div className="overview-header">

                    <span>

                        ABOUT TIGI INDUSTRIES

                    </span>

                    <h2>

                        Engineering Packaging Solutions
                        Built on Innovation, Precision & Trust.

                    </h2>

                    <p>

                        TIGI Industries India Pvt. Ltd. specializes in delivering
                        industrial packaging solutions designed to protect products,
                        improve operational efficiency and support diverse manufacturing
                        industries. Every solution is developed with a commitment to
                        quality, reliability and long-term customer value.

                    </p>

                </div>

                <div className="row g-4 mt-5">

                    <div className="col-lg-6">

                        <div className="purpose-card">

                            <div className="purpose-icon">

                                <FaEye />

                            </div>

                            <h3>

                                Our Vision

                            </h3>

                            <p>

                                To become one of India's trusted industrial packaging
                                manufacturers by delivering innovative, reliable and
                                sustainable packaging solutions that empower businesses
                                across diverse industries.

                            </p>

                        </div>

                    </div>

                    <div className="col-lg-6">

                        <div className="purpose-card">

                            <div className="purpose-icon">

                                <FaBullseye />

                            </div>

                            <h3>

                                Our Mission

                            </h3>

                            <ul>

                                <li>Deliver dependable packaging solutions.</li>

                                <li>Continuously improve quality and manufacturing.</li>

                                <li>Create value through innovation.</li>

                                <li>Build lasting customer partnerships.</li>

                            </ul>

                        </div>

                    </div>

                </div>

                                {/* Core Values */}

                                <div className="values-section">

<div className="section-title">

    <span>

        OUR VALUES

    </span>

    <h3>

        Principles That Guide Everything We Do

    </h3>

</div>

<div className="row g-4">

    {

        values.map((value,index)=>(

            <div
                className="col-lg-3 col-md-6"
                key={index}
            >

                <div className="value-card">

                    <div className="value-icon">

                        {value.icon}

                    </div>

                    <h4>

                        {value.title}

                    </h4>

                    <p>

                        {value.text}

                    </p>

                </div>

            </div>

        ))

    }

</div>

</div>

{/* Closing Statement */}

<div className="company-closing">

<div className="closing-line"></div>

<h3>

    Packaging Beyond Products

</h3>

<p>

    At TIGI Industries, we believe exceptional packaging goes beyond manufacturing quality products. It is about understanding customer challenges, delivering dependable solutions and building partnerships founded on trust, consistency and long-term value.

</p>

</div>

</div>

</section>

);

}

export default CompanyOverview;